import React, { Component } from 'react'
import { connect } from 'react-redux'

import PhotoUploader from './Inspections/PhotoUploader'
import WindowSpinner from './WindowSpinner'
import HoleLine from './Inspections/HoleLine'

import { loadLots, loadRestores } from '../actions'

const initialState = {
  showUpload: true,
  lot: ''
}

class Restores extends Component {
  constructor() {
    super()
    this.state = initialState
  }

  changeLot(e) {
    const v = e.target.value
    this.setState({ lot: v }, () => {
      if (v !== '') {
        this.props.loadRestores(v)
      }
    })
  }

  reload() {
    this.props.loadLots()
    const v = this.props.restores.lot
    if (v !== '') {
      this.props.loadRestores(v)
    }
  }

  componentDidMount() {
    if (this.props.detections.lots === null) {
      this.props.loadLots()
    }
    this.setState({ lot: this.props.restores.lot })
  }

  render() {
    const s = this.state
    const { lots, loading } = this.props.detections
    const { list } = this.props.restores
    const loadingRestores = this.props.restores.loading
    return (
      <div className='full-page'>
        <h1>Manutenzioni</h1>
        <button className='lnk-det-refresh' onClick={() => this.reload()}>
          <i className='fas fa-sync-alt'></i>
        </button>
        <select value={s.lot} onChange={(e) => this.changeLot(e)}>
          <option value=''></option>
          {(lots || [])
            .filter((x) => x.id !== 0 && x.count > 0)
            .map((l, index) => {
              return (
                <option key={index} value={l.id}>
                  {l.name} ({l.count})
                </option>
              )
            })}
        </select>
        <table className='tbl-datas'>
          <thead>
            <tr>
              <th>stato</th>
              <th>id</th>
              <th>indirizzo</th>
              <th>ultima rilevazione</th>
              <th>tipo anomalia</th>
              <th>Interventi Stimati</th>
              <th>Interventi Eseguiti</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            {s.lot !== '' &&
              (list || []).map((d, index) => {
                return (
                  <HoleLine
                    imInRestores
                    key={index}
                    setChecked={this.setChecked}
                    chkList={this.state.chkList}
                    d={d}
                  />
                )
              })}
          </tbody>
        </table>
        {s.lot !== '' && (
          <PhotoUploader
            footprint={{
              lot: s.lot,
              field_label: 'repaired',
              field_value: '1'
            }}
            canDrag={true}
            onRef={(ref) => (this.child = ref)}
          />
        )}
        {(loading || loadingRestores) && <WindowSpinner />}
      </div>
    )
  }
}

function mapStateToProps(state) {
  return state
}

export default connect(mapStateToProps, { loadLots, loadRestores })(Restores)
